import React, { useEffect, useState, useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController,
} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels'
import { useToasts } from 'react-toast-notifications'
import { Chart } from 'react-chartjs-2'
import { useSelector } from 'react-redux'
import axiosInstance from '../../../../../services/config/AxiosIntance'
import Loader from '../../../../../components/Loader'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'
import { chartThreeMonthColors } from '../../../../../constant/constant'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController
)

const HiredApplicants = () => {
  const filters = useSelector((state) => state.dashboard.filters)
  const { addToast } = useToasts()

  const [loading, setLoading] = useState(false)
  const [chartData, setChartData] = useState({
    labels: [''],
    datasets: [],
  })

  useEffect(() => {
    setLoading(true)
    const queryParams = new URLSearchParams(filters).toString()

    axiosInstance
      .get(`/dashboard/hired-applicants?${queryParams}`)
      .then((res) => {
        const datasets = res?.data?.result?.datasets.map((item, index) => {
          if (item.name === 'Hiring %') {
            return {
              type: 'line',
              label: item.name,
              data: item.data,
              borderColor: 'red',
              backgroundColor: 'red',
              yAxisID: 'y1', // secondary axis
              tension: 0.3,
              fill: false,
              pointRadius: 5, // 🔥 circle markers
              pointBackgroundColor: 'white',
              pointBorderColor: 'red',
              pointBorderWidth: 2,
              order: 1, // 🔥 ensures line is drawn on top
            }
          }
          return {
            type: 'bar',
            label: item.name,
            data: item.data,
            backgroundColor: chartThreeMonthColors[index],
            borderColor: chartThreeMonthColors[index],
            borderWidth: 1,
            barPercentage: 1.0,
            order: 2, // draw below line
          }
        })

        setChartData({
          labels: res.data.result.labels,
          datasets,
        })
      })
      .catch((err) => {
        addToast(
          err?.response?.message ||
          err?.response?.data?.message ||
          'Internal Server Error',
          {
            appearance: 'error',
            autoDismiss: true,
          }
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [filters])

  const options = useMemo(
    () => ({
      maintainAspectRatio: false,
      plugins: {
        title: {
          color: 'black',
          display: true,
          align: 'start',
          position: 'top',
          text: `Hiring Rate`,
          font: {
            size: 24,
            family: "'Lato', 'sans-serif'",
            weight: 300,
          },
        },
        datalabels: {
          formatter: (value, ctx) => {
            if (ctx.dataset.label === 'Hiring %') {
              return value === 0 ? '' : value + '%'
            }
          },
          display: (ctx) => {
            if (ctx.dataset.label === 'Hiring %') return true
            return Boolean(ctx.dataset.data !== 0)
          },
          color: (ctx) => (ctx.dataset.label === 'Hiring %' ? 'red' : 'black'),
          anchor: (ctx) =>
            ctx.dataset.label === 'Hiring %' ? 'end' : 'center',
          align: (ctx) => (ctx.dataset.label === 'Hiring %' ? 'top' : 'center'),
          offset: (ctx) => (ctx.dataset.label === 'Hiring %' ? 20 : 0),
          clamp: true,
        },
      },
      responsive: true,
      scales: {
        x: {
          stacked: false,
          grid: { display: false },
        },
        y: {
          stacked: false,
          grid: { display: false },
          ticks: { padding: 0.5 },
          title: { display: true, text: 'Applicants' },
        },
        y1: {
          position: 'right',
          grid: { drawOnChartArea: false },
          ticks: {
            callback: (value) => value + '%',
          },
          title: { display: true, text: 'Hiring %' },
        },
      },
    }),
    []
  )

  const component = loading ? (
    <Loader />
  ) : chartData.labels.length ? (
    <Chart
      type="bar"
      options={options}
      data={chartData}
      plugins={[ChartDataLabels]}
    />
  ) : (
    <>
      <DashboardItemTitle title="Hiring Rate" />
      <NoData />
    </>
  )

  return component
}

export default HiredApplicants
